import { required, email, helpers, minLength } from '@vuelidate/validators'; //regex, minLength

export const fieldInputValidator = (value) => {
    return {
        required: helpers.withMessage(value + ' is required', required),
    };
};

export const emailValidator = () => {
    return {
        required: helpers.withMessage('Email field is empty', required),
        email: helpers.withMessage('Email is invalid', email),
    };
};

export const passwordValidator = (value) => {
    return {
        required: helpers.withMessage(value + ' field cannot be empty', required),
        minLength: minLength(8),
        // alphaNum
        // regex: regex(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)
    };
};

export const handleValidationErrors = (errors) => {
    let validationError = [];
    // Handle validation errors here
    for (const error of errors.inner) {
        const errorString = snakeToCamel(error.path);
        // populates the error message
        validationError[errorString] = error.message;
    }
    return validationError;
};

// converts strings like company_id to companyId
function snakeToCamel(str) {
    return str.replace(/_([a-z])/g, (_, match) => match.toUpperCase());
}

// export const fieldLengthValidator = (len) => {
//     return {
//         required: helpers.withMessage('Minimum length should be ', len),
//         minLength: minLength(len),
//     };
// };
